import { makeStyles } from "@fluentui/react-components";

export const useLoginFormStyles = makeStyles({
  flexColumnStyle: {
    display: "flex",
    flexDirection: "column",
  },
  flexCentered: {
    justifyContent: "center",
    justifyItems: "center",
    alignItems: "center",
  },
  textUpperCase: {
    textTransform: "uppercase",
  },
  fullWidth: {
    width: "100%",
  },
  formContainer: {
    rowGap: "17px",
  },
  submitBtn: {
    fontSize: "12.80px",
    lineHeight: "22.53px",
    wordWrap: "break-word",
    height: "55px",
    borderRadius: "8px",
  },
});
